import type { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { TokenService } from '../services/token.service';

export const sessionInterceptor: HttpInterceptorFn = (req, next) => {
  const token = inject(TokenService).getToken();
  if (!token) return next(req);

  return next(
    req.clone({
      setHeaders: { session: token }, // or Authorization: `Bearer ${token}`
    })
  );
};

//e.x. token: 8211b26c-011c-420f-bcc6-4a81f1a8276a
